export default __webpack_public_path__ + "static/media/033-dice.688fc67b.png";